export const coursesData = {
    python: {
        id: "python",
        title: "Python Masterclass",
        description: "Learn Python from scratch with 10 modules.",
        videos: [
            {
                id: 1,
                title: "Module 1: Introduction to Python",
                description: "An introduction to the Python programming language. Learn what Python is, why it is popular, and how to set up your environment.",
                youtubeId: "XoADNxgUXQc",
            },
            {
                id: 2,
                title: "Module 2: Variables and Data Types",
                description: "Learn about variables and data types in Python including integers, floats, strings, and booleans.",
                youtubeId: "aiNzCBM5Apc",
            },
            {
                id: 3,
                title: "Module 3: Operators and Expressions",
                description: "Learn about arithmetic, comparison, and logical operators in Python.",
                youtubeId: "I4l9GXYSav4",
            },
            {
                id: 4,
                title: "Module 4: Input and Output",
                description: "Learn about taking input from users and displaying output with print statements and f-strings.",
                youtubeId: "CJ2t9w03H3Q",
            },
            {
                id: 5,
                title: "Module 5: Conditional Statements",
                description: "Learn about if, elif, and else statements to control the flow of your program.",
                youtubeId: "306kEUrTxJo",
            },
            {
                id: 6,
                title: "Module 6: Loops",
                description: "Learn about for and while loops, the break and continue statements.",
                youtubeId: "vAFCn_fZmu8",
            },
            {
                id: 7,
                title: "Module 7: Functions",
                description: "Learn about defining and calling functions, parameters, return values, and scope.",
                youtubeId: "oO7ufW7jnO0",
            },
            {
                id: 8,
                title: "Module 8: Collections",
                description: "Learn about lists, tuples, sets, and dictionaries in Python.",
                youtubeId: "35PQlrukzgE",
            },
            {
                id: 9,
                title: "Module 9: Libraries",
                description: "Learn how to use Python's built-in libraries and install third-party packages.",
                youtubeId: "BBw2quQB2Io",
            },
            {
                id: 10,
                title: "Module 10: File Handling & Exceptions",
                description: "Learn about reading and writing files, and handling errors with try-except blocks.",
                youtubeId: "ol_SYwSvsF8",
            },
        ]
    },
    javascript: {
        id: "javascript",
        title: "JavaScript Fundamentals",
        description: "Master JavaScript basics and advanced concepts in 10 days. Go from zero to confident JavaScript developer.",
        videos: [
            {
                id: 1,
                title: "Day 1: Introduction to JavaScript",
                description: "Discover what JavaScript is, how it runs in the browser, and write your very first lines of code. Learn the history and role of JavaScript in web development.",
                youtubeId: "W6NZfCO5SIk",
            },
            {
                id: 2,
                title: "Day 2: Variables, Data Types & Operators",
                description: "Learn how to declare variables using var, let, and const. Explore JavaScript data types: strings, numbers, booleans, null, undefined, and objects.",
                youtubeId: "9emXNzqCKyg",
            },
            {
                id: 3,
                title: "Day 3: Functions & Scope",
                description: "Write reusable blocks of code with functions. Understand function declarations vs expressions, arrow functions, parameters, return values, and variable scope.",
                youtubeId: "xUI5Tsl2JpY",
            },
            {
                id: 4,
                title: "Day 4: Objects & Arrays",
                description: "Learn how to group related data using objects and ordered collections using arrays. Explore dot notation, bracket notation, array methods like push, pop, map, and filter.",
                youtubeId: "37YIF_evtEk",
            },
            {
                id: 5,
                title: "Day 5: Control Flow – If, Loops & Switch",
                description: "Control how your code executes with if-else statements, switch-case, for loops, while loops, and the break and continue keywords.",
                youtubeId: "IsG4Xd6LlsM",
            },
            {
                id: 6,
                title: "Day 6: DOM Manipulation",
                description: "Learn how JavaScript interacts with HTML. Select elements with querySelector, change content, styles, and attributes dynamically to build interactive web pages.",
                youtubeId: "5fb2aPlgoys",
            },
            {
                id: 7,
                title: "Day 7: Events & Event Listeners",
                description: "Make your pages respond to user actions. Handle click, keydown, submit, and other events using addEventListener, event.target, and event bubbling.",
                youtubeId: "XF1_MlZ5l6M",
            },
            {
                id: 8,
                title: "Day 8: Asynchronous JS – Callbacks, Promises & Async/Await",
                description: "Understand how JavaScript handles time-consuming operations. Learn about the event loop, callbacks, Promises, .then().catch() chaining, and the modern async and await syntax.",
                youtubeId: "PoRJizFvM7s",
            },
            {
                id: 9,
                title: "Day 9: Fetch API & Working with APIs",
                description: "Connect to real-world data sources using the Fetch API. Learn how to make GET and POST requests, parse JSON responses, and handle errors from external APIs.",
                youtubeId: "cuEtnrL9-H0",
            },
            {
                id: 10,
                title: "Day 10: Final Project – Build a JavaScript App",
                description: "Apply everything you have learned by building a complete JavaScript application. Covers project structure, best practices, debugging, and deploying your app to the web.",
                youtubeId: "G3e-cpL7ofc",
            },
        ]
    },
    react: {
        id: "react",
        title: "React 10 Days Learning",
        description: "Learn React step by step in 10 days. Go from JavaScript to building full-featured, accessible React applications.",
        videos: [
            {
                id: 1,
                title: "Day 1: What is React & Why Use It?",
                description: "Introduction to React, its component-based architecture, virtual DOM, and how it compares to plain JavaScript. Set up a project using Create React App or Vite.",
                youtubeId: "RGKi6LSPDLU",
            },
            {
                id: 2,
                title: "Day 2: JSX & Functional Components",
                description: "Learn JSX syntax for writing HTML inside JavaScript. Create your first functional components and understand how React renders them to the DOM.",
                youtubeId: "Ke90Tje7VS0",
            },
            {
                id: 3,
                title: "Day 3: Props – Passing Data Between Components",
                description: "Learn how to pass data to child components using props. Understand prop types, default props, and how to build reusable components with props.",
                youtubeId: "PHaECbrKgs0",
            },
            {
                id: 4,
                title: "Day 4: State & useState Hook",
                description: "Learn how to manage local component state using the useState hook. Build interactive components that re-render in response to user actions.",
                youtubeId: "O6P86uwfdR0",
            },
            {
                id: 5,
                title: "Day 5: Handling Events in React",
                description: "Handle user interactions in React: onClick, onChange, onSubmit events. Learn how synthetic events work, event handlers, and controlled components with forms.",
                youtubeId: "Znqv84xi8Vs",
            },
            {
                id: 6,
                title: "Day 6: useEffect Hook & Side Effects",
                description: "Understand the React component lifecycle and how to run side effects with useEffect. Fetch data on mount, clean up subscriptions, and use the dependency array.",
                youtubeId: "UVhIMwHds54",
            },
            {
                id: 7,
                title: "Day 7: React Router – Client-Side Navigation",
                description: "Add multi-page navigation to React apps using React Router. Set up routes, navigate between pages with Link, and use useNavigate and useParams hooks.",
                youtubeId: "Jppuj4KPMpg",
            },
            {
                id: 8,
                title: "Day 8: Context API – Sharing Global State",
                description: "Avoid prop-drilling by sharing data across the component tree with Context API. Create context, wrap providers, and consume values using useContext hook.",
                youtubeId: "5LrDIWkK_Bc",
            },
            {
                id: 9,
                title: "Day 9: Custom Hooks",
                description: "Extract reusable logic from components into custom hooks. Build and use custom hooks for data fetching, form handling, and more.",
                youtubeId: "6ThXsUwLWvc",
            },
            {
                id: 10,
                title: "Day 10: Final Project – Build a React Application",
                description: "Combine everything to build a complete React application from scratch. Covers project organisation, performance optimisation, and deploying your React app.",
                youtubeId: "w7ejDZ8SWv8",
            },
        ]
    },
    html: {
        id: "html",
        title: "HTML & Accessibility Fundamentals",
        description: "Learn HTML from the ground up with a focus on semantic structure and screen reader support. Understand how assistive technologies parse web pages.",
        videos: [
            {
                id: 1,
                title: "Module 1: What is HTML?",
                description: "Introduction to HTML — what it is, how browsers read it, and why it matters for accessibility. Understand the relationship between HTML and screen readers.",
                youtubeId: "qz0aGYrrlhU",
            },
            {
                id: 2,
                title: "Module 2: HTML Document Structure",
                description: "Learn the basic structure of an HTML document: DOCTYPE, html, head, and body tags. Understand how screen readers navigate document landmarks.",
                youtubeId: "UB1O30fR-EE",
            },
            {
                id: 3,
                title: "Module 3: Headings, Paragraphs & Text",
                description: "Use headings (h1-h6) to create a clear content hierarchy. Learn how screen reader users navigate by headings to quickly find content.",
                youtubeId: "yqcd-XkxZNM",
            },
            {
                id: 4,
                title: "Module 4: Links & Navigation",
                description: "Create accessible links with descriptive text. Learn why 'Click here' is bad for screen readers and how to build keyboard-navigable menus.",
                youtubeId: "gqOEoUR5RHg",
            },
            {
                id: 5,
                title: "Module 5: Images & Alt Text",
                description: "Add images to web pages with proper alt attributes. Learn the difference between decorative and informative images for screen reader users.",
                youtubeId: "_w6N_nplmAw",
            },
            {
                id: 6,
                title: "Module 6: Lists & Tables",
                description: "Structure data with ordered lists, unordered lists, and tables. Understand how screen readers announce table headers and cells.",
                youtubeId: "HeQfRnVhU3I",
            },
            {
                id: 7,
                title: "Module 7: Forms & Input Accessibility",
                description: "Build accessible forms with proper labels, fieldsets, and error messages. Learn how screen readers handle form controls.",
                youtubeId: "fF9ykfHWkPk",
            },
            {
                id: 8,
                title: "Module 8: Semantic HTML5 Elements",
                description: "Use header, nav, main, article, section, aside, and footer elements. Understand how landmarks help screen reader users navigate pages efficiently.",
                youtubeId: "kGW8Al_cga4",
            },
            {
                id: 9,
                title: "Module 9: ARIA Roles & Attributes",
                description: "Introduction to WAI-ARIA: roles, states, and properties. Learn when to use ARIA and when native HTML semantics are sufficient.",
                youtubeId: "0hqhAIjE_8I",
            },
            {
                id: 10,
                title: "Module 10: Building a Screen Reader Friendly Page",
                description: "Capstone project: build a complete, accessible web page from scratch. Test with a screen reader and validate against WCAG guidelines.",
                youtubeId: "aqM6rV5IBlg",
            },
        ]
    },
    css: {
        id: "css",
        title: "CSS for Accessible Design",
        description: "Learn CSS with a focus on creating visually accessible, responsive designs. Covers high contrast, focus indicators, and low-vision-friendly techniques.",
        videos: [
            {
                id: 1,
                title: "Module 1: Introduction to CSS",
                description: "What is CSS and how it works with HTML. Learn inline, internal, and external stylesheets. Understand how CSS affects screen reader behavior.",
                youtubeId: "yfoY53QXEnI",
            },
            {
                id: 2,
                title: "Module 2: Colors, Contrast & Readability",
                description: "Choose accessible color combinations that meet WCAG contrast ratios. Learn tools to check color contrast for low-vision users.",
                youtubeId: "HY8q4TD3KGM",
            },
            {
                id: 3,
                title: "Module 3: Typography & Readable Text",
                description: "Select accessible fonts, sizes, and line-heights. Understand how font choices impact readability for users with low vision.",
                youtubeId: "RNakAX3rVVw",
            },
            {
                id: 4,
                title: "Module 4: Box Model & Layout Basics",
                description: "Understand margin, padding, border, and width. Learn how the box model affects the visual layout of accessible components.",
                youtubeId: "rIO5326FgPE",
            },
            {
                id: 5,
                title: "Module 5: Flexbox for Accessible Layouts",
                description: "Build flexible, responsive layouts with Flexbox. Learn how visual order vs DOM order affects screen reader experience.",
                youtubeId: "u044iM9xsWU",
            },
            {
                id: 6,
                title: "Module 6: CSS Grid & Responsive Design",
                description: "Create complex layouts with CSS Grid. Build mobile-first, responsive pages that work with zoom and screen magnifiers.",
                youtubeId: "EiNiSFIPIQE",
            },
            {
                id: 7,
                title: "Module 7: Focus Styles & Keyboard Visibility",
                description: "Design visible focus indicators for keyboard users. Learn why removing outlines is harmful and how to create beautiful focus styles.",
                youtubeId: "Mvu5OMGcdVA",
            },
            {
                id: 8,
                title: "Module 8: Animations & Reduced Motion",
                description: "Add CSS animations and transitions safely. Respect the prefers-reduced-motion media query to prevent motion sickness.",
                youtubeId: "N5EW4HnF6FU",
            },
            {
                id: 9,
                title: "Module 9: CSS for Screen Reader Content",
                description: "Use CSS to visually hide content while keeping it accessible to screen readers. The sr-only pattern and skip-navigation links.",
                youtubeId: "QW_dUs9D1oQ",
            },
            {
                id: 10,
                title: "Module 10: Building an Accessible Portfolio",
                description: "Capstone project: style your HTML portfolio with accessible CSS. High contrast mode, responsive design, and WCAG AA compliance.",
                youtubeId: "oYRda7UtuhA",
            },
        ]
    },
};
